import React, { useState, useEffect } from "react";
import { Backdrop, Box, CircularProgress, Divider } from "@mui/material";
import ListEditCandidateInfo from "./list-edit-candidates/ListEditCandidateInfo";
import {
  useAllInterview,
  useInterviewById,
} from "../../../../store/query/scheduleInterviewQuery";
import { useLocation } from "react-router-dom";
import { MainEditInterviewContainer } from "./style";
import EditCandidateInfo from "./edit-candidate/EditCandidateInfo";
const EditScheduleInterview = () => {
  const location = useLocation();
  const selectedCandidateId = location.state?.selectedCandidate || null;
  const [filterOptions, setFilterOptions] = useState({
    page: 1,
    limit: "",
    name: "",
    status: "All",
  });
  const {
    data: interviewList,
    isLoading,
    isError,
  } = useAllInterview({
    page: filterOptions.page,
    limit: filterOptions.limit,
    status: filterOptions.status,
    search: filterOptions.name,
  });
  const [selectedInterviewId, setSelectedInterviewId] =
    useState(selectedCandidateId);
  const { data: selectedInterviewDataById, isLoading: isInterviewLoading } =
    useInterviewById(selectedInterviewId);
  const [selectedInterview, setSelectedInterview] = useState(null);
  const [backDrop, setBackDrop] = useState(false);

  useEffect(() => {
    setBackDrop(isInterviewLoading);
  }, [isInterviewLoading]);

  useEffect(() => {
    if (interviewList?.length > 0) {
      const initialInterview =
        interviewList.find((item) => item._id === selectedCandidateId) ||
        interviewList[0];

      setSelectedInterview(initialInterview);
      setSelectedInterviewId(initialInterview?._id || selectedCandidateId);
    }
  }, [interviewList, selectedCandidateId]);

  const handleChatClick = (id) => {
    setSelectedInterviewId(id);
  };

  if (isError) return <p>Error fetching interviews!</p>;

  return (
    <MainEditInterviewContainer>
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={backDrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <ListEditCandidateInfo
        interview={interviewList}
        handleChatClick={handleChatClick}
        selectedInterview={selectedInterview}
        selectedCandidateId={selectedInterviewId}
      />
      <EditCandidateInfo selectedInterviewData={selectedInterviewDataById} />
    </MainEditInterviewContainer>
  );
};

export default EditScheduleInterview;
